import { useApolloClient } from '@apollo/client';
import { usePackageContext } from '@openx/components-package/utils/context/PackageContext.tsx';
import type { PackageOperationData } from '@openx/types/package/PackageHookTypes.ts';
import { usePackageArchive } from './usePackageArchive.ts';

export const usePackageOperationActions = () => {
  const apolloClient = useApolloClient();

  const { usePackageClone } = usePackageContext();

  const { clonePackage } = usePackageClone();

  const { archivePackage } = usePackageArchive();

  const clonePackages = async (packages: PackageOperationData[]) => {
    await clonePackage({ packages });
    apolloClient.refetchQueries({ include: ['GetPackageList', 'GetOpenxCuratedPackages'] });
  };

  const deletePackages = async (packages: PackageOperationData[]) => {
    await archivePackage(packages);
    apolloClient.refetchQueries({ include: ['GetPackageList', 'GetOpenxCuratedPackages'] });
  };

  return { clonePackages, deletePackages };
};
